export const EStoresAction = {
  SET_STORES: 'SET_STORES',
  SET_SELECTED_STORE: 'SET_SELECTED_STORE',
  SET_USERS_FOR_STORE: 'SET_USERS_FOR_STORE',
  SET_PAGINATION: 'SET_PAGINATION_STORES',
  SET_REPORT_STORE: 'SET_REPORT_STORE',
  SET_REPORT_STOCK: 'SET_REPORT_STOCK',
  SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
};
